import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy, OnInit } from '@angular/core';

import { of } from 'rxjs';
import { tap } from 'rxjs/operators';

import { EnvironmentCreate } from '../../interfaces';
import { FsSkeletonModule } from '@firestitch/skeleton';
import { FormsModule } from '@angular/forms';
import { FsFormModule } from '@firestitch/form';
import { MatCardContent, MatCardActions } from '@angular/material/card';
import { MatFormField, MatLabel, MatHint } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatButton } from '@angular/material/button';


@Component({
    selector: 'app-workspace',
    templateUrl: './workspace.component.html',
    styleUrls: ['./workspace.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        FsSkeletonModule,
        FormsModule,
        FsFormModule,
        MatCardContent,
        MatFormField,
        MatLabel,
        MatInput,
        MatHint,
        MatCardActions,
        MatButton,
    ]
})
export class WorkspaceComponent implements OnInit {

  @Input() public environmentCreate: EnvironmentCreate = null;

  @Output() public environmentCreateChange = new EventEmitter<EnvironmentCreate>();

  constructor() { }

  public ngOnInit(): void {
  }

  public save = () => {
    return of(this.environmentCreate)
      .pipe(
        tap((response) => this.environmentCreateChange.emit(response)),
      );
  };

}
